import _ from 'lodash'
import config from './config'
import { router, authHeader, authHeaderUpload } from '@/_helpers'
import { localStore } from '@/_utils/localstore'
import { AccessRight } from '@/_enums/access_right'

export function commonService(endpoint: any) {
  return {
    getAll,
    addOne,
    getOne,
    updateOne,
    updateStatic,
    deleteOne,
    uploadFile,
    importCSV,
    hasRefs,
    canEdit,
    canDelete,
    isReadOnly
  }
  async function getAll(params: any = {}): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: authHeader()
    }
    const url = new URL(`${config.apiUrl}/${endpoint}`)
    // Add params to url
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

    return await fetch(url.href, (requestOptions as any)).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function addOne(data: any): Promise<any> {
    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: JSON.stringify(data)
    }

    return await fetch(`${config.apiUrl}/${endpoint}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function updateOne(data: any): Promise<any> {
    const requestOptions = {
      method: 'PATCH',
      headers: authHeader(),
      body: JSON.stringify(data)
    }

    return await fetch(`${config.apiUrl}/${endpoint}/${data._id}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function updateStatic(data: any): Promise<any> {
    const requestOptions = {
      method: 'PATCH',
      headers: authHeader(),
      body: JSON.stringify(data)
    }

    return await fetch(`${config.apiUrl}/${endpoint}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function getOne(id: string): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: authHeader(),
    }

    return await fetch(`${config.apiUrl}/${endpoint}/${id}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function deleteOne(id: string): Promise<any> {
    const requestOptions = {
      method: 'DELETE',
      headers: authHeader(),
    }

    return await fetch(`${config.apiUrl}/${endpoint}/${id}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function uploadFile(file: File): Promise<any> {
    // Create new form data to upload
    const data = new FormData()
    data.append('file', file)
    const requestOptions = {
      method: 'POST',
      headers: authHeaderUpload(),
      body: data,
    }

    return await fetch(`${config.apiUrl}/api/v1/upload`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function importCSV(file: File, params: any = {}): Promise<any> {
    const data = new FormData()
    data.append('file', file)
    const requestOptions = {
      method: 'POST',
      headers: authHeaderUpload(),
      body: data,
    }
    const url = new URL(`${config.apiUrl}/${endpoint}/importcsv`);

    // Add params to url
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

    return await fetch(url.href, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function hasRefs(id: string): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: authHeader(),
    }

    return await fetch(`${config.apiUrl}/${endpoint}/${id}/has-refs`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  function canEdit() {
    return !isReadOnly()
  }

  function canDelete() {
    return !isReadOnly()
  }

  function isReadOnly() {
    const user = JSON.parse(localStore.getItem('user') as string)
    if (!user || !_.isNumber(user.access_right)) {
      router.push('/login').catch(error => false)
    }

    return user.access_right === AccessRight.observer
  }

  function handleResponse(response: any): any {
    return response.text().then((text: string) => {
      const responseJson = text && JSON.parse(text)
      if (!response.ok) {
        // Token expire or not logged in, goto login page
        if (response.status === 401) {
          router.push('/login').catch(error => false)
        }

        const errorMsg = (responseJson && responseJson.message) || response.statusText
        return Promise.reject(errorMsg)
      }

      return Promise.resolve(responseJson)
    })
  }
}
